// extracted by mini-css-extract-plugin
export default {"melodyVideo":"nN-z","isFullWidth":"oN-z","landingPageVideo":"pN-z","play":"qN-z","iframeVideo":"rN-z","playHidden":"sN-z","fullwidth":"tN-z"};